//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { reverseNaturalSort } from '@/helpers/util';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';
import { importPlotly } from './Plotly';
import BaseChart from './baseChart';

let d3Ref;

export default {
  name: 'DpKpiPieChart',
  mixins: [BaseChart],
  props: {
    valuesToShow: { type: Number, default: () => 5 },
    kpi: { type: Object, default: null },
    chartParams: { type: Object, required: true },
  },
  data() {
    return {
      legendElements: [],
    };
  },
  computed: {
    ...mapGetters(COLOURS, [PALETTE_COLOURS]),
  },
  watch: {
    chartParams: {
      handler() {
        this.run();
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    this.clearLegendEvents();
  },
  methods: {
    async run() {
      if (!this.chartParams || !this.chartParams.data) return;
      const rawData = this.chartParams.data;
      const data = reverseNaturalSort(rawData.values, 'y');

      const values = [];
      const labels = [];

      // Construct the trace data arrays
      let currentCount = 0;
      data.forEach((d) => {
        if (currentCount <= this.valuesToShow) {
          values[currentCount] = d.y;
          labels[currentCount] = d.x;
          currentCount += 1;
        } else {
          values[this.valuesToShow] += d.y;
          labels[this.valuesToShow] = 'Other';
        }
      });

      // Setup the basic pie chart
      const trace = [{
        values,
        labels,
        type: 'pie',
        pull: 0,
        marker: {
          colors: this[PALETTE_COLOURS].chart,
        },
        textinfo: 'percent',
        textposition: 'inside',
        textfont: {
          color: '#FFF',
        },
      }];

      const hiddenLegendItems = [];
      if (this.kpi) {
        const state = this.kpi.getState();
        Object.keys(state).forEach((k) => {
          if (state[k] && state[k].visible === false) {
            hiddenLegendItems.push(k);
          }
        });
      }

      const layout = {
        margin: this.margins,
        font: {
          family: 'Proxima Nova, Arial',
        },
        plot_bgcolor: 'transparent',
        paper_bgcolor: 'transparent',
        showlegend: true,
        legend: {
          orientation: 'v',
          // traceorder: 'normal',
          x: 0,
          y: -0.75,
          font: {
            color: this[PALETTE_COLOURS].dark,
          },
        },
        hiddenlabels: hiddenLegendItems,
      };

      const { Plotly, d3 } = await importPlotly();
      d3Ref = d3;

      Plotly.newPlot(this.$refs.element, trace, layout, { showLink: false }).then(() => {
        this.canResize = true;
        this.resize();

        const emitLegendClick = (t) => {
          this.$emit('click-legend', t);
        };

        // Remove any old legend events
        this.clearLegendEvents();

        // Attach legend events
        const legend = this.$refs.element.querySelector('g.legend');
        const vm = this;
        d3.select(legend).selectAll('.traces').each(function bindTrace() {
          const item = d3.select(this);
          item.on('click', (d) => {
            const { label } = d[0];
            const { hiddenlabels } = vm.$refs.element.layout;
            const hidden = hiddenlabels.includes(label);
            emitLegendClick({ name: label, visible: !hidden });
          });
          vm.legendElements.push(item);
        });
      });
    },
    clearLegendEvents() {
      // d3Ref should be present if we are running this
      if (!d3Ref) return;

      this.legendElements.forEach((e) => {
        const item = d3Ref.select(e);
        item.on('click', null);
      });
      this.legendElements = [];
    },
  },
};
